var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchived(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    fill: "white",
    stroke: "#D9622A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9997 19C14.8664 19 14.6664 18.9334 14.5997 18.8667L12.5997 17.2C12.333 16.9334 12.2664 16.5334 12.533 16.2667C12.7997 16 13.1997 15.9334 13.4664 16.2L15.0664 17.5334L16.6664 16.2C16.933 15.9334 17.3997 16 17.5997 16.2667C17.8664 16.5334 17.7997 17 17.533 17.2L15.533 18.8667C15.333 18.9334 15.133 19 14.9997 19Z",
    fill: "#D9622A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9987 19C14.5987 19 14.332 18.7333 14.332 18.3333V14.3333C14.332 13.9333 14.5987 13.6666 14.9987 13.6666C15.3987 13.6666 15.6654 13.9333 15.6654 14.3333V18.3333C15.6654 18.6666 15.3987 19 14.9987 19Z",
    fill: "#D9622A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8654 21.6667H10.132C9.13203 21.6667 8.33203 20.8667 8.33203 19.8667V11.6667C8.33203 11.2667 8.5987 11 8.9987 11H20.9987C21.3987 11 21.6654 11.2667 21.6654 11.6667V19.8667C21.6654 20.8667 20.8654 21.6667 19.8654 21.6667ZM9.66536 12.3333V19.8667C9.66536 20.1333 9.86536 20.3333 10.132 20.3333H19.8654C20.132 20.3333 20.332 20.1333 20.332 19.8V12.3333H9.66536Z",
    fill: "#D9622A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0008 12.3334H9.0008C8.73414 12.3334 8.53414 12.2 8.4008 11.9334C8.26747 11.6667 8.33414 11.4667 8.46747 11.2667L10.2675 8.86671C10.5341 8.53337 10.9341 8.33337 11.3341 8.33337H18.6675C19.0675 8.33337 19.4675 8.53337 19.7341 8.86671L21.5341 11.2667C21.6675 11.4667 21.7341 11.7334 21.6008 11.9334C21.4675 12.2 21.2675 12.3334 21.0008 12.3334ZM10.3341 11H19.6675L18.6675 9.66671H11.3341L10.3341 11Z",
    fill: "#D9622A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchived);
export default __webpack_public_path__ + "static/media/archived.2ef405aedb1e52913c36047881d58177.svg";
export { ForwardRef as ReactComponent };